import { DrawerLink } from '../Drawer';
import InfoIcon from '../Icon/InfoIcon';

export interface HelpDrawerLinkProps {
  /** Callback when the link is clicked */
  onClick: () => void;
  /** Custom link text */
  text?: string;
  /** Additional CSS class name if needed */
  className?: string;
  /** Test ID for automated testing */
  'data-testid'?: string;
}

/**
 * HelpDrawerLink component
 *
 * Displays a link that opens the help drawer when clicked.
 * Shows "Get Help with this Page" text with an info icon by default.
 *
 * @example
 * <HelpDrawerLink onClick={() => setIsHelpOpen(true)} />
 * <HelpDrawerLink text="Get Help" onClick={() => setIsHelpOpen(true)} />
 */
export const HelpDrawerLink = ({
  onClick,
  text = 'Get Help with this Page',
  className = '',
  'data-testid': dataTestId,
}: HelpDrawerLinkProps) => {
  return (
    <DrawerLink
      className={className}
      data-testid={dataTestId ?? 'help-drawer-link'}
      icon={<InfoIcon size={18} />}
      text={text}
      onClick={onClick}
    />
  );
};
